import type { SEOPropsType } from '..';

export const SEO_HYDROCORTISONE_CONTENT: SEOPropsType = {
  title: 'Hydrocortisone Prescription - Curology Custom Formula',
};
